import { initSentry } from '$lib/services/telemetry';

// Initialize Sentry on app startup.
// Guards internally on: production env, user preference, DSN configured.
initSentry();
